import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import HeroPng2x from './assets/Hero@2x.png'
import HeroWebp from './assets/Hero.webp'
import HeroWebp2x from './assets/Hero@2x.webp'

const copy = {
  overline: `Warehouses`,
  heading: `Segment for the Warehouse`,
  description: `Segment gives your business the tools necessary to centralize, link and activate customer records so that your data teams and marketing teams can work together.`,
  buttonText: `Get a demo`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroCopy>
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p">{copy.description}</CopyText.Description>
          </CopyTextBase>
          <HeroRecipe.Form>
            <StyledDemoForm
              data-hook="demoFormContainer"
              isProgressive={true}
              customFormIdentifier="site-warehouses-demo"
              successMessageAppearance="twilioLight"
            />
          </HeroRecipe.Form>
        </HeroCopy>
        <HeroRecipe.Contents>
          <Picture>
            <source type="image/webp" srcSet={`${HeroWebp}, ${HeroWebp2x} 2x`} />
            <Image width="640" height="386" src={HeroPng2x} alt="Illustration: Hero" loading="lazy" />
          </Picture>
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

const Wrapper = styled.header`
  position: relative;
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const HeroCopy = styled(HeroRecipe.Copy)`
  max-width: 510px;
`

const StyledDemoForm = styled(DemoForm)`
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    text-align: left;
  }
`

export default Hero
